import { DateType, EPriceTime, getMarkAreaData } from '@/pages/EnergyAnalysisRanking/utils';
import { keepPercentOrLine, keepTwoNull } from '@/utils/utils';
import { V2EnergyUnitRankingsDetailPostResponse } from '@maxtropy/device-customer-apis-v2';
import dayjs from 'dayjs';
export const getModalChartOption = ({
  xLabel,
  timeResolution,
  chartData,
  ePriceTimes,
  query,
  dataQueryPeriodName,
}: {
  xLabel: string;
  timeResolution?: DateType;
  chartData?: V2EnergyUnitRankingsDetailPostResponse;
  ePriceTimes?: EPriceTime[];
  query?: any;
  dataQueryPeriodName?: string;
}) => {
  // 用能单元
  let unitValueData = (chartData?.chartValue ?? []).map(item => [dayjs(item.ts).valueOf(), item.value]);

  const times = chartData?.chartValue?.map(item => dayjs(item.ts).valueOf()) || [];
  // 判断是否数据都为null
  const legendData = [
    {
      name: '尖时段用量',
      color: '#FF6D2C',
    },
    {
      name: '峰时段用量',
      color: '#CE90D1',
    },
    {
      name: '平时段用量',
      color: '#0DB6D9',
    },
    {
      name: '谷时段用量',
      color: '#63BC7F',
    },
  ];

  const seriesData = () => {
    if (chartData?.energyMediumId === 2030) {
      return [
        {
          barMaxWidth: 80,
          name: `尖时段用量`,
          type: 'bar',
          stack: 'total',
          data: chartData?.chartValue?.map(item => [
            dayjs(item.ts).valueOf(),
            item.summitValue,
            item.value,
            item.summitRate,
          ]),
          itemStyle: {
            color: '#FF6D2C', // 图形颜色
          },
        },
        {
          name: `峰时段用量`,
          type: 'bar',
          stack: 'total',
          data: chartData?.chartValue?.map(item => [
            dayjs(item.ts).valueOf(),
            item.peakValue,
            item.value,
            item.peakRate,
          ]),
          itemStyle: {
            color: '#CE90D1', // 图形颜色
          },
        },
        {
          name: `平时段用量`,
          type: 'bar',
          stack: 'total',
          data: chartData?.chartValue?.map(item => [
            dayjs(item.ts).valueOf(),
            item.plainValue,
            item.value,
            item.plainRate,
          ]),
          itemStyle: {
            color: '#0DB6D9', // 图形颜色
          },
        },
        {
          name: `谷时段用量`,
          type: 'bar',
          stack: 'total',
          data: chartData?.chartValue?.map(item => [
            dayjs(item.ts).valueOf(),
            item.valleyValue,
            item.value,
            item.valleyRate,
          ]),
          itemStyle: {
            color: '#63BC7F', // 图形颜色
          },
        },
      ];
    }
    return [
      {
        name: chartData?.energyUnitName,
        type: 'bar',
        data: unitValueData,
        itemStyle: {
          color: '#16DD8E',
        },
      },
    ];
  };

  return {
    tooltip: {
      formatter: (items: any) => {
        let { axisValue, data } = items[0];
        let firstStr = dayjs(axisValue).format(xLabel);
        let otherStr = '';
        let str = '';
        if (data[2]) {
          otherStr += `<div style="margin-top:8px"><span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;"></span>总用量: &nbsp;${keepTwoNull(
            data[2]
          )}${chartData?.physicalUnitName ?? '--'}</div>`;
          str = firstStr + otherStr;
        }
        if (
          (chartData?.energyMediumId === 2030 && timeResolution !== DateType.DAY) ||
          chartData?.energyMediumId !== 2030
        ) {
          items.forEach((item: any) => {
            const { seriesName, data, marker } = item;
            otherStr += `<div style="margin-top:8px"><span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;">${marker}</span>${seriesName} : &nbsp;${keepTwoNull(
              data[1]
            )}${chartData?.physicalUnitName ?? '--'}
            ${
              chartData?.energyMediumId === 2030 && timeResolution !== DateType.DAY
                ? `占比：${keepPercentOrLine(data[3])}%`
                : ''
            }
            </div>`;
            str = firstStr + `${dataQueryPeriodName ? dataQueryPeriodName + '总用量' : ''}` + otherStr;
          });
        }
        return str;
      },
    },
    backgroundColor: 'transparent',
    // color: legendData.map(i => i.color),
    dataZoom: [
      {
        type: 'slider',
        bottom: 15,
        left: 40,
        right: 20,
        height: 10,
        textStyle: {
          fontSize: 10,
        },
        labelFormatter: (value: string) => {
          return dayjs(value).format(xLabel);
        },
      },
    ],
    legend: {
      right: 80,
      top: 4,
      itemWidth: 12,
      itemHeight: 12,
      data: legendData.map(item => ({
        name: item.name,
      })),
    },
    toolbox: {
      width: 60,
      height: 100,
      right: 10,
      itemSize: 20, // 设置图标大小
      feature: {
        brush: {
          type: ['lineX', 'clear'], // 选择工具类型
          title: {
            lineX: '横向选择',
            clear: '清除',
          },
        },
      },
    },
    brush: {
      toolbox: ['lineX', 'clear'],
      xAxisIndex: 0,
    },
    xAxis: [
      {
        type: 'time',
        axisLabel: {
          formatter: function (e: number) {
            // return dayjs(e, 'x').format(xLabel);
            return times.includes(e) ? dayjs(e, 'x').format(xLabel) : '';
          },
        },
      },
    ],
    yAxis: [
      {
        type: 'value',
        name: chartData?.physicalUnitName ?? '--',
      },
    ],
    series: [
      ...seriesData(),
      {
        type: 'line',
        name: '均值',
        markLine: {
          silent: true,
          symbol: ['none', 'none'],
          label: {
            formatter: `平均值: {@[1]}${chartData?.physicalUnitName}`,
            position: 'insideEndTop',
            color: '#FACC58',
          },
          lineStyle: {
            color: '#FACC58',
            type: 'dashed',
          },
          data: [{ yAxis: keepTwoNull(chartData?.avgValue) }],
        },
        markArea: {
          silent: true,
          data:
            chartData?.energyMediumId === 2030 && timeResolution === DateType.DAY
              ? getMarkAreaData(ePriceTimes, query)
              : [],
        },
      },
    ],
  };
};
